import e from"styled-components";const t={opacity:{[!0]:1,[!1]:.5}},o=e.div`
	display: flex;
	gap: 8px;
	user-select: none;
`,n=e.span`
	display: flex;
	gap: 2px;

	*:after {
		opacity: 0.65;
	}
`,r=e.div`
	background-color: ${({theme:e,isSelected:t=!1})=>t?`${e.text.brand}26`:"transparent"};
	border: 1px solid ${({theme:e})=>e.border.black50};
	padding: 6px 12px;
	color: ${({theme:e})=>e.border.black50};
	transition: background-color ease 0.1s, color ease 0.1s;
	font-size: 12px;
	border-radius: 9999px;
	display: flex;
	align-items: center;
	gap: 6px;
	height: 32px;
	box-sizing: border-box;
	cursor: pointer;
	white-space: nowrap;

	&:last-child {
		z-index: 10;
	}

	&:hover {
		background-color: ${({theme:e})=>e.text.brand}33;
	}
`,i=e.div`
	background-color: transparent;
	cursor: pointer;
	display: grid;
	place-content: center;
	opacity: ${({hasOpacity:e=!0})=>t.opacity[e]};

	${({hasRotation:e=!1})=>e&&"\n      transform: rotate(180deg)\n    "};
`,a=e.div`
	display: flex;
	align-items: center;
`,d=e(i)`
	height: 32px;
	box-sizing: border-box;
	border: 0.5px dashed ${({theme:e})=>e.text.text};
	border-radius: 9999px;
	padding-inline: 12px;
	transition: background-color ease 0.1s;
	z-index: 10;

	&:hover {
		background-color: rgba(0, 175, 255, 0.15);
	}
`,p=e.div`
	outline: none;
	min-height: 0.1px;
	line-height: 24px;
	cursor: ${({contentEditable:e})=>e?"text":"pointer"};

	${({contentEditable:e,hasContent:t})=>e&&!t?'\n        &:after {\n          position: static;\n          content: "Insert text";\n          opacity: 0.2;\n        }\n      ':""}
`;export{o as Container,n as Content,p as EditableContentContainer,d as NewTabButton,i as TabButton,a as TabButtonsContainer,r as TabContainer};
